import React from 'react';
import { TextComponentProps } from '@components/text/text-props.type';
import { StyledEyebrow } from './eyebrow.styled';

const Eyebrow = ({
  fontColor = 'primaryLight',
  stringText,
  className,
  fontSize = 'eyebrow',
  margin = 'md',
}: TextComponentProps): JSX.Element => (
  <StyledEyebrow $fontColor={fontColor} $fontSize={fontSize} className={className} $margin={margin}>
    {stringText}
  </StyledEyebrow>
);

export default Eyebrow;
